import Head from "next/head";
import Image from "next/image";

const preloadedSrcs = new Set<string>();

export function LazyImage(props: any) {
  const { width, height, fill, priority, alt, src, ...rest } = props;

  if (!width && !height && !fill) {
    console.warn("LazyImage: You must provide either width/height or fill.");
  }

  const safeSizes = width ? `${width}px` : "100vw";

  const preloadSrc = priority && src && !preloadedSrcs.has(src);
  if (preloadSrc) preloadedSrcs.add(src);

  return (
    <>
      {preloadSrc && (
        <Head>
          <link rel="preload" as="image" href={src} />
        </Head>
      )}
      <Image
        {...props}
        loading="eager"
        quality={75}
        alt={alt || ""}
        sizes={safeSizes}
      />
    </>
  );
}
